export default {
  name: "FooterSection",
  data() {
    return {
      rights: {
        company_name: "AI Campus",
        year: new Date().getFullYear(),
      },
      footer_links: [
        { label: "Portfolio intelligence", href: "#features" },
        { label: "Utilities", href: "#features" },
        { label: "Connectivity", href: "#features" },
        { label: "Security", href: "#features" },
      ],
      platform_links: [
        { label: "Sign in", to: "/login" },
        { label: "Reset password", to: "/reset_password" },
      ],
    };
  },
};
